// removed by extract-text-webpack-plugin
module.exports = {"button":"Button__button___3vjDD","buttonRelative":"Button__buttonRelative___2VNgR","verySmall":"Button__verySmall___djMbP","small":"Button__small___qZ9C5","medium":"Button__medium___3uCnX","large":"Button__large___1tISh","companyPrimary":"Button__companyPrimary___1X3Xh","primary":"Button__primary___Dv0Je","secondary":"Button__secondary___3phaU","noMarginBottom":"Button__noMarginBottom___2ep0J","blue":"Button__blue___bARRQ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/button/Button.scss
// module id = 1059
// module chunks = 0